import { useSelector } from 'react-redux'
import { selectHomebotNetworkEnabled } from '../store/selectors/customerProfile'

export const useVerificationFlowEnabled = (): boolean => {
  const homebotNetworkEnabled = useSelector(selectHomebotNetworkEnabled)

  return homebotNetworkEnabled
}
